import React, { Component } from "react";
import style from "./AddInventory.module.css";
import api from "../../utils/Api";
import history from "../../utils/history";
import ttmLoader from "../../assets/images/ttm-loader.gif";
// import DatePicker from "react-datepicker";
import { DatePicker } from "antd";
import { connect } from "react-redux";
import moment from "moment";
import AddInventoryPhotos from "../../components/AddInventoryPhotos/AddInventoryPhotos";
import { fetchDropdownList } from "../../redux";
import { date } from "yup";
import { NAME_MESSAGE, NAME_REGEX } from "../../utils/RegexConstants";

export class AddInventory extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isPageTitle: "Add Product",
      product_name: "",
      unique_code: "",
      category_id: "",
      sub_category_id: "",
      manufacture_date: "",
      loading_date: moment(),
      sales_date: "",
      expiry_date: "",
      supplier: "",
      manufacturer: "",
      notes: "",
      nappi_code: "",
      quantity: "",
      unit_price: "",
      successMessage: "",
      errorMessage: "",
      isLoading: false,
      error: "",
      subCatDropdownList: [],
      productSpecificDetails: [],
      filteredSubCatOptionsData: [],
      uploadPictures: [],
      isEdit: false,
      deleteProductImages: [],
      editImages: [],
      isScreenLoaded: false,
      maxPictureUpload:
        localStorage.getItem("SETTING_INFO") &&
        JSON.parse(localStorage.getItem("SETTING_INFO"))
          .max_product_image_upload,
      isQuantityNumberAllowed: "",
      isNumberAllowedUnitPrice: "",
      showErrors: {}
      // isUniqueNumberAllowed: "",
      // isNappiCodeAllowed: "",
      // isProductNamellowed: "",
    };
  }

  componentDidMount = async() => {
    document.title = 'Edit Product - TechToMedix';
    // Ftech dropdwon options for sub category
    await this.getDropdown();

    // Fetching route parameters
    if (this.props.match.params.id) {
      this.setState(
        {
          isPageTitle: "Update Product",
          isEdit: true,
          productSpecificDetails: this.props.location.state,
        },
        async () => {
          // fetch specific product details
        this.fetchProductDetails();
          // Fetch edit picture
        await this.getEditPictures();
        }
      );
    }else{
      
    this.setState({
      
      isEdit: false,
      product_name: "",
      unique_code: "",
      category_id: "",
      sub_category_id: "",
      manufacture_date: "",
      loading_date: moment(),
      sales_date: "",
      expiry_date: "",
      supplier: "",
      manufacturer: "",
      notes: "",
      nappi_code:"",
      quantity: "",
      unit_price: "",
      productSpecificDetails:{}
    });
    }
    setTimeout(() => {
      this.setState({
        isScreenLoaded: true,
      });
    }, 2000);
  }


  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.id != this.props.match.params.id) {
      this.setState({
        isEdit: false,
        product_name: "",
        unique_code: "",
        category_id: "",
        sub_category_id: "",
        manufacture_date: "",
        loading_date: moment(),
        sales_date: "",
        expiry_date: "",
        supplier: "",
        manufacturer: "",
        notes: "",
        nappi_code: "",
        quantity: "",
        unit_price:"",
        isPageTitle: "Add Product",
      });
    }
  }

  getDropdown = async () => {
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    try {
      const response = await api.get("inventory/dropdown/fetch", {
        headers: headers,
      });
      if (response.status == 200) {
       // console.log("####response", response.data.data);
        this.setState({
          subCatDropdownList: response.data.data,
        });
      }
    } catch (error) {
      console.log(
        "Error for fetching sub dropdown from add product page",
        error
      );
    }
  };

  getEditPictures = async () => {
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    try {
      const response = await api.get(
        "inventory/image/fetch?inventory_id=" + this.props.match.params.id,
        {
          headers: headers,
        }
      );
      if (response.status == 200) {
      //  console.log("Edit product image", response.data.data);
        this.setState({ editImages: response.data.data });
      }
    } catch (error) {
      console.log("Error in get edit pictures", error);
    }
  };

  // Calling fetch specific product details
  fetchProductDetails = () => {
    // console.log(
    //   "++++++++++++++this.state.productSpecificDetails",
    //   this.state.productSpecificDetails
    // );
    this.setState({
      product_name: this.state.productSpecificDetails.product_name,
      unique_code: this.state.productSpecificDetails.unique_code,
      category_id: this.state.productSpecificDetails.category_id,
      sub_category_id: this.state.productSpecificDetails.sub_category_id,
      manufacture_date: this.state.productSpecificDetails.manufacture_date,
      loading_date: this.state.productSpecificDetails.loading_date,
      sales_date: this.state.productSpecificDetails.salesby_date,
      expiry_date: this.state.productSpecificDetails.expiry_date,
      supplier: this.state.productSpecificDetails.Supplier,
      manufacturer: this.state.productSpecificDetails.Manufacturer,
      notes: this.state.productSpecificDetails.notes,
      nappi_code: this.state.productSpecificDetails.nappi_code,
      quantity: this.state.productSpecificDetails.quantity,
      unit_price: this.state.productSpecificDetails.unit_price,
    });
  };

  handleInputChange = (event) => {
    const val = event.target.value;
    const name = event.target.name;
    this.setState(
      {
        [name]: val,
      },
      () => {
        this.removeErrors();
      }
    );
    if (name === "category_id") {
      let filteredSubCatOptionsData = this.state.subCatDropdownList.filter(
        (element, index) => {
          return element.category_id == val;
        }
      );
      this.setState({
        filteredSubCatOptionsData: filteredSubCatOptionsData
      })

      if (this.state.filteredSubCatOptionsData.length === 0) {
        this.setState({
          sub_category_id: "",
        });
      }
    }

    if (name === "quantity") {
      this.validateNumbersOnlyQ(event);
    }
    if (name === "unit_price") {
      this.validateNumbersOnlyU(event);
    }


    if (name === "supplier" || name === "manufacturer") {
      const regex = NAME_REGEX;
      if (!regex.test(val)) {
        let showErrors = {...this.state.showErrors};
        showErrors[name] = NAME_MESSAGE;
        this.setState({
          showErrors:showErrors
        })
      } else {
        let showErrors = {...this.state.showErrors};
        showErrors[name] = "";
        delete showErrors[name];
        this.setState({
          showErrors:showErrors
        })
      }
    }
    
    if (name === "product_name") {
      const regex = /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/;
      if (!regex.test(val)) {
        let showErrors = {...this.state.showErrors};
        showErrors[name] = "Only alphanumeric values are allowed!";
        this.setState({
          showErrors:showErrors
        })
      } else {
        let showErrors = {...this.state.showErrors};
        showErrors[name] = "";
        delete showErrors[name];
        this.setState({
          showErrors:showErrors
        })
      }
    }
    if (name === "unique_code") {
      const regex = /^[A-Za-z0-9]*$/;
      if (!regex.test(val)) {
        let showErrors = {...this.state.showErrors};
        showErrors[name] = "Only alphanumeric values are allowed!";
        this.setState({
          showErrors:showErrors
        })
      } else {
        let showErrors = {...this.state.showErrors};
        showErrors[name] = "";
        delete showErrors[name];
        this.setState({
          showErrors:showErrors
        })
      }
    }
    
    if (name === "nappi_code") {
      const regex = /^[0-9]*$/;
      if (!regex.test(val)) {
        let showErrors = {...this.state.showErrors};
        showErrors[name] = "Only numbers are allowed!";
        this.setState({
          showErrors:showErrors
        })
      } else {
        let showErrors = {...this.state.showErrors};
        showErrors[name] = "";
        delete showErrors[name];
        this.setState({
          showErrors:showErrors
        })
      }
    }

  };

  // Validations for only numbers allowed
  validateNumbersOnlyQ = (e) => {
    const regex = /^[0-9]*$/;

    if (!regex.test(e.target.value)) {
      this.setState({
        isNumberAllowed: "Enter only numbers",
      });
    } else {
      this.setState({
        isNumberAllowed: "",
      });
    }
  };

  validateNumbersOnlyU = (e) => {
    const regex = /^[0-9]*$/;

    if (!regex.test(e.target.value)) {
      this.setState({
        isNumberAllowedUnitPrice: "Enter only numbers",
      });
    } else {
      this.setState({
        isNumberAllowedUnitPrice: "",
      });
    }
  };

  handleChangeManufDate = (date) => {
    this.setState({
      manufacture_date: date,
    });
    this.removeErrors();
  };
  handleChangeLoadDate = (date) => {
    this.setState({
      loading_date: date,
    });
    this.removeErrors();
  };
  handleChangeSaleDate = (date) => {
    this.setState({
      sales_date: date,
    });
    this.removeErrors();
  };
  handleChangeExpDate = (date) => {
    this.setState({
      expiry_date: date,
    });
    this.removeErrors();
  };

  handleInputBlurChange = () => {
    this.removeErrors();
  };

  removeErrors = () => {
    if (
      this.state.product_name !== "" &&
      this.state.unique_code !== "" &&
      this.state.category_id !== "" &&
      this.state.sub_category_id !== "" &&
      this.state.manufacture_date !== "" &&
      this.state.loading_date !== "" &&
      this.state.sales_date !== "" &&
      this.state.expiry_date !== "" &&
      this.state.supplier !== "" &&
      this.state.manufacturer !== "" &&
      this.state.nappi_code !== "" &&
      this.state.quantity !== "" && 
      this.state.unit_price !== "" 
    ) {
      this.setState({
        error: "",
      });
    } else {
      this.setState({
        error: "Please filled out all mandatory fields",
      });
    }
  };

  // Getting picture data
  getPicData = (pictureData) => {
    this.setState({
      uploadPictures: pictureData,
    });
  };

  gotoBack = () => {
    history.push("/inventorylist");
  };


  // Disabled expiry date
  disabledExpiryDate = (current) => {
    let salesDate = this.state.sales_date;
    return (
      (current && current < moment().endOf("day")) ||
      (current && current < moment(salesDate).endOf("day"))
    );
  };

  onSubmit = async () => {
    if (
      this.state.product_name == "" ||
      this.state.unique_code == "" ||
      this.state.category_id == "" ||
      this.state.sub_category_id == "" ||
      this.state.manufacture_date == "" ||
      this.state.manufacture_date == null ||
      this.state.loading_date == "" ||
      this.state.loading_date == null ||
      this.state.sales_date == "" ||
      this.state.sales_date == null ||
      this.state.expiry_date == "" ||
      this.state.expiry_date == null ||
      this.state.supplier == "" ||
      this.state.manufacturer == "" ||
      this.state.nappi_code == "" ||
      this.state.quantity === "" || 
      this.state.unit_price === "" 
    ) {
      this.setState({
        error: "Please filled out all mandatory fields",
      });
    } else {
      if (
        (this.state.isNumberAllowed === "" ||
          this.state.isNumberAllowed === undefined) &&
        (this.state.isNumberAllowedUnitPrice === "" ||
          this.state.isNumberAllowedUnitPrice === undefined)
        // this.state.isProductNamellowed === ""
      ) {
        if(Object.keys(this.state.showErrors).length !== 0){
         // console.log("show errors", this.state.showErrors)
          this.setState({
            error: "Please fill valid details!",
          });
          return false;
        }
        this.setState({
          error: "",
          isLoading: true,
        });

        const formData = new FormData();
        formData.append("product_name", this.state.product_name);
        formData.append("unique_code", this.state.unique_code);
        formData.append("category_id", this.state.category_id);
        formData.append(
          "manufacture_date",
          moment(this.state.manufacture_date).format("YYYY-MM-DD")
        );
        formData.append(
          "loading_date",
          moment(this.state.loading_date).format("YYYY-MM-DD")
        );
        formData.append(
          "salesby_date",
          moment(this.state.sales_date).format("YYYY-MM-DD")
        );
        formData.append(
          "expiry_date",
          moment(this.state.expiry_date).format("YYYY-MM-DD")
        );
        formData.append("sub_category_id", this.state.sub_category_id);
        formData.append("supplier", this.state.supplier);
        formData.append("manufacturer", this.state.manufacturer);
        formData.append("notes", this.state.notes);
        formData.append("nappi_code", this.state.nappi_code);
        formData.append("quantity", this.state.quantity);
        formData.append("unit_price", this.state.unit_price);

        const deleteImage = [];
        this.state.uploadPictures.map((element, index) => {
          if (element.isNewUpload) {
            formData.append("attachment", element.selectedFile);
          }
          if (element.delete) {
            deleteImage.push(element.attachment_id);
          }
        });

        if (this.state.isEdit) {
          formData.append("inventory_id", this.props.match.params.id);
          formData.append("deleteProductImages", JSON.stringify(deleteImage));
        }

        // Headers
        const headers = {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
        };
        try {
          const response = await api.post("inventory", formData, {
            headers: headers,
          });
         // console.log("*************response", response);
          if (response.status === 200) {
            this.setState({
              isLoading: false,
              successMessage: "Product added successfully!",
            });
            if (this.state.isEdit) {
              this.setState({
                isLoading: false,
                successMessage: "Product updated successfully!",
              });
            }
            setTimeout(() => {
              this.setState({
                successMessage: "",
              });
              history.push("/inventorylist");
            }, 2000);
          }
        } catch (error) {
          if (error.response) {
            this.setState({
              isLoading: false,
              errorMessage: "Internal server error occured",
            });
            setTimeout(() => {
              this.setState({
                errorMessage: "",
              });
            }, 2000);
          }
        }
      }
    }
  };

  render() {
    // getting dropdown list options from redux persist
    const catDropdownData = this.props.dropdownListData.dropdownList.category;

    // getting category dropdwon options
    const catOptionsData =
      catDropdownData &&
      catDropdownData.map((element, index) => (
        <option key={index} value={element.category_id}>
          {element.category_name}
        </option>
      ));

    this.state.filteredSubCatOptionsData = this.state.subCatDropdownList.filter(
      (element, index) => {
        return element.category_id == this.state.category_id;
      }
    );

    const subCatOptionsData = this.state.filteredSubCatOptionsData.map(
      (element, index) => (
        <option key={index} value={element.sub_category_id}>
          {element.sub_category_name}
        </option>
      )
    );
    if (!this.state.isScreenLoaded) {
      return (
        <div className="dashboard-loader">
          <img src={ttmLoader} alt="loader" className="loader-image" />
        </div>
      );
    }

    return (
      <div className={style.addInventoryMainWrapper}>
        <div className="row">
          <div className="col-lg-12">
            <h3>{this.state.isPageTitle}</h3>
          </div>
          <div className="col-lg-12 intro-text">
            <p className="mb-4">
              Here the new products can be added to the inventory. The main
              category to be selected first and then the subcategory appear.
              Maximum 3 pictures can be uploaded per product
            </p>
          </div>
        </div>
        <div class="form-box-shadow">
          <div className="row">
            <div className="col-lg-12">
              <h6>Product Details</h6>
            </div>
            <div className="col-md-6 col-lg-4 col-xl-3">
              <div className="form-group">
                <label htmlFor="name">
                  Label/Name{" "}
                  <span className="mandatory">
                    <small>*</small>
                  </span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="product_name"
                  onChange={this.handleInputChange}
                  value={this.state.product_name}
                  onKeyPress={this.numericFilter}
                  maxLength="20"
                  className={`form-control ${this.state.showErrors &&
                    this.state.showErrors.product_name
                      ? "is-invalid"
                      : ""
                  }`}
                />
                {this.state.showErrors.product_name !== "" && (
                  <p>
                    <span className="error">
                      {this.state.showErrors.product_name}
                    </span>
                  </p>
                )}
              </div>
            </div>
            <div className="col-md-6 col-lg-4 col-xl-3">
              <div className="form-group">
                <label htmlFor="unique_code">
                  Unique Code{" "}
                  <span className="mandatory">
                    <small>*</small>
                  </span>
                </label>
                <input
                  type="text"
                  id="unique_code"
                  name="unique_code"
                  value={this.state.unique_code}
                  onChange={this.handleInputChange}
                  maxLength="20"
                  className={`form-control ${this.state.showErrors &&
                    this.state.showErrors.unique_code
                      ? "is-invalid"
                      : ""
                  }`}
                />
                {this.state.showErrors.unique_code !== "" && (
                  <p>
                    <span className="error">
                      {this.state.showErrors.unique_code}
                    </span>
                  </p>
                )}
              </div>
            </div>
            <div className="col-md-6 col-lg-4 col-xl-3">
              <div className="form-group">
                <label htmlFor="category">
                  Category{" "}
                  <span className="mandatory">
                    <small>*</small>
                  </span>
                </label>
                <select
                  id="category"
                  name="category_id"
                  className="form-control"
                  onChange={this.handleInputChange}
                  value={this.state.category_id}
                >
                  <option value="">Select category</option>
                  {catOptionsData}
                </select>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 col-xl-3">
              <div className="form-group">
                <label htmlFor="category">
                  Sub Category{" "}
                  <span className="mandatory">
                    <small>*</small>
                  </span>
                </label>
                <select
                  id="sub_category_id"
                  name="sub_category_id"
                  className="form-control"
                  onChange={this.handleInputChange}
                  value={this.state.sub_category_id}
                  disabled={!this.state.category_id}
                >
                  <option value="">Select Sub Category</option>
                  {subCatOptionsData}
                </select>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 col-xl-3">
              <div className="form-group">
                <label htmlFor="manufacture_date">
                  Manufacture Date{" "}
                  <span className="mandatory">
                    <small>*</small>
                  </span>
                </label>
                <DatePicker
                  selected={
                    this.state.manufacture_date
                      ? new Date(this.state.manufacture_date)
                      : null
                  }
                  onChange={this.handleChangeManufDate}
                  name="manufacture_date"
                  dateFormat="yyyy-MM-dd"
                  className="form-control"
                  value={
                    this.state.manufacture_date
                      ? moment(this.state.manufacture_date)
                      : ""
                  }
                />
              </div>
            </div>
            <div className="col-md-6 col-lg-4 col-xl-3">
              <div className="form-group">
                <label htmlFor="loading_date">
                  Loading Date{" "}
                  <span className="mandatory">
                    <small>*</small>
                  </span>
                </label>
                <DatePicker
                  selected={
                    this.state.loading_date
                      ? new Date(this.state.loading_date)
                      : null
                  }
                  onChange={this.handleChangeLoadDate}
                  name="loading_date"
                  dateFormat="yyyy-MM-dd"
                  className="form-control"
                  defaultValue={moment()}
                  disabledDate={(d) =>
                    d.isBefore(moment()) || d.isAfter(moment())
                  }
                />
              </div>
            </div>
            <div className="col-md-6 col-lg-4 col-xl-3">
              <div className="form-group">
                <label htmlFor="sales_date">
                  Sell by Date{" "}
                  <span className="mandatory">
                    <small>*</small>
                  </span>
                </label>
                <DatePicker
                  selected={
                    this.state.sales_date
                      ? new Date(this.state.sales_date)
                      : null
                  }
                  onChange={this.handleChangeSaleDate}
                  name="sales_date"
                  dateFormat="yyyy-MM-dd"
                  className="form-control"
                  disabledDate={(d) => d.isBefore(new Date())}
                  value={
                    this.state.sales_date ? moment(this.state.sales_date) : ""
                  }
                />
              </div>
            </div>
            <div className="col-md-6 col-lg-4 col-xl-3">
              <div className="form-group">
                <label htmlFor="expiry_date">
                  Expiry Date{" "}
                  <span className="mandatory">
                    <small>*</small>
                  </span>
                </label>
                <DatePicker
                  selected={
                    this.state.expiry_date
                      ? new Date(this.state.expiry_date)
                      : null
                  }
                  onChange={this.handleChangeExpDate}
                  name="expiry_date"
                  dateFormat="yyyy-MM-dd"
                  className="form-control"
                   disabledDate={(d) => d.isBefore(new Date()) || d.isBefore(this.state.sales_date)}
                  //disabledDate={this.disabledExpiryDate}
                  value={
                    this.state.expiry_date ? moment(this.state.expiry_date) : ""
                  }
                />
              </div>
            </div>
            <div className="col-md-6 col-lg-4 col-xl-3">
              <div className="form-group">
                <label htmlFor="supplier">
                  Supplier{" "}
                  <span className="mandatory">
                    <small>*</small>
                  </span>
                </label>
                <input
                  type="text"
                  id="supplier"
                  name="supplier"
                  value={this.state.supplier}
                  onChange={this.handleInputChange}
                  maxLength="20"
                  className={`form-control ${this.state.showErrors &&
                    this.state.showErrors.supplier
                      ? "is-invalid"
                      : ""
                  }`}
                />
                {this.state.showErrors.supplier !== "" && (
                  <p>
                    <span className="error">
                      {this.state.showErrors.supplier}
                    </span>
                  </p>
                )}
              </div>
            </div>
            <div className="col-md-6 col-lg-4 col-xl-3">
              <div className="form-group">
                <label htmlFor="manufacturer">
                  Manufacturer{" "}
                  <span className="mandatory">
                    <small>*</small>
                  </span>
                </label>
                <input
                  type="text"
                  id="manufacturer"
                  name="manufacturer"
                  value={this.state.manufacturer}
                  onChange={this.handleInputChange}
                  maxLength="20"
                  className={`form-control ${this.state.showErrors &&
                    this.state.showErrors.manufacturer
                      ? "is-invalid"
                      : ""
                  }`}
                />
                {this.state.showErrors.manufacturer !== "" && (
                  <p>
                    <span className="error">
                      {this.state.showErrors.manufacturer}
                    </span>
                  </p>
                )}
              </div>
            </div>
            <div className="col-md-6 col-lg-4 col-xl-3">
              <div className="form-group">
                <label htmlFor="additional_notes">Additional Notes</label>
                <input
                  type="text"
                  className="form-control"
                  id="additional_notes"
                  name="notes"
                  maxLength="50"
                  value={this.state.notes}
                  onChange={this.handleInputChange}
                />
              </div>
            </div>
            <div className="col-md-6 col-lg-4 col-xl-3">
              <div className="form-group">
                <label htmlFor="nappi_code">
                  Nappi Code{" "}
                  <span className="mandatory">
                    <small>*</small>
                  </span>
                </label>
                <input
                  type="text"
                  id="nappi_code"
                  name="nappi_code"
                  maxLength="20"
                  value={this.state.nappi_code}
                  onChange={this.handleInputChange}
                  className={`form-control ${this.state.showErrors &&
                    this.state.showErrors.nappi_code
                      ? "is-invalid"
                      : ""
                  }`}
                />
                {this.state.showErrors.nappi_code !== "" && (
                  <p>
                    <span className="error">
                      {this.state.showErrors.nappi_code}
                    </span>
                  </p>
                )}
              </div>
            </div>
            <div className="col-md-6 col-lg-4 col-xl-3">
              <div className="form-group">
                <label htmlFor="quantity">
                  Quantity{" "}
                  <span className="mandatory">
                    <small>*</small>
                  </span>
                </label>
                <input
                  type="text"
                  id="quantity"
                  name="quantity"
                  value={this.state.quantity}
                  onChange={this.handleInputChange}
                  onBlur={this.handleInputBlurChange}
                  maxLength="4"
                  className={`form-control ${
                    this.state.isNumberAllowed ? "is-invalid" : ""
                  }`}
                />
                {this.state.isNumberAllowed && (
                  <span className="error">{this.state.isNumberAllowed}</span>
                )}
              </div>
            </div>
            <div className="col-md-6 col-lg-4 col-xl-3">
              <div className="form-group">
                <label htmlFor="unit_price">
                  Unit Price(ZAR){" "}
                  <span className="mandatory">
                    <small>*</small>
                  </span>
                </label>
                <input
                  type="text"
                  id="unit_price"
                  name="unit_price"
                  value={this.state.unit_price}
                  onChange={this.handleInputChange}
                  onBlur={this.handleInputBlurChange}
                  maxLength="4"
                  className={`form-control ${
                    this.state.isNumberAllowedUnitPrice ? "is-invalid" : ""
                  }`}
                />
                {this.state.isNumberAllowedUnitPrice && (
                  <span className="error">
                    {this.state.isNumberAllowedUnitPrice}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>

        {this.state.maxPictureUpload !== 0 && (
          <div className={`form-box-shadow ${style.uploadMainWrapper}`}>
            <div className="row">
              <div className="col-lg-12">
                {/* <h6>Upload Pictures</h6>
              {/* <div className="form-group">
                <div className={style.uploadBtnWrapper}>
                  <button type="button" className={style.uploadBtn}>
                    <i className="fa fa-upload mr-2" aria-hidden="true"></i>
                    Upload
                  </button>
                  <input
                    type="file"
                    name="selectedFile"
                    className={style.uploadInput}
                  />
                </div>
              </div> */}

                <div className="mb-3">
                  <h6 className={style.proofHeading}>Upload Pictures</h6>
                  <small>
                    {`You can upload maximum  ${this.state.maxPictureUpload} pictures and allowed extensions are .jpg, .png, .svg.`}
                  </small>
                  <br />
                  {/* <small>Allowed extentions are .jpg, .png, .svg</small> */}
                </div>
                <AddInventoryPhotos
                  propsState={this.state}
                  getPicData={this.getPicData}
                />
              </div>
            </div>
          </div>
        )}

        {this.state.error && (
          <div className={`error ${style.errorText}`}>{this.state.error}</div>
        )}
        <div
          className={`d-flex justify-content-center justify-content-sm-end ${style.btnWrapper}`}
        >
          <button
            type="submit"
            class="tmed-btn tmed-primary-btn"
            onClick={this.onSubmit}
          >
            Save
          </button>
        </div>
        <div className="row">
          <div className="col-md-12">
            {this.state.isLoading ? (
              <div className={style.loadingWrapper}>
                <img src={ttmLoader} className={style.loading} />
              </div>
            ) : (
              <div>
                {this.state.successMessage && (
                  <p className={style.successMessage}>
                    {this.state.successMessage}
                  </p>
                )}
                {this.state.errorMessage && (
                  <p className={style.errorMessage}>
                    {this.state.errorMessage}
                  </p>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    dropdownListData: state.dropdownList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDropdownList: () => dispatch(fetchDropdownList()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddInventory);
